
import Component from '../../../assets/scripts/modules/component'
import SwiperWrapper from '../../../assets/scripts/modules/swiper-wrapper'

const SWIPER_OPTIONS = {
  loop: false,
  slidesPerView: 1,
  spaceBetween: 15,
  grabCursor: false,
  breakpoints: {
    530: { slidesPerView: 2 },
    800: { slidesPerView: 2 },
    1180: { slidesPerView: 2 },
    1580: { slidesPerView: 2 },
    2240: { slidesPerView: 2 }
  }
}

export default class CardCarouselComponent extends Component {
  async init () {
    this.container = this.element.querySelector('.featured-card-carousel__swiper-container')

    if (!this.container) {
      return
    }

    this.loadSwiper()
  }

  loadSwiper () {
    const options = { ...SWIPER_OPTIONS }
    this.swiperWrapper = new SwiperWrapper(this.container, options)
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.featured-card-carousel').forEach(element => {
  element.instance = element.instance || new CardCarouselComponent(element)
}))
